import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestWrap } from '../../core/models/request-wrap';
import { MenuItem } from '../models/menu-items';
import { environment } from '../../../environments/environment';
import { handleEmpty } from '../../core/helpers/rx-pipes';

const menusUrl = '/menus'

@Injectable()
export class MenusService {
  constructor(private http: HttpClient) {}

  getMenusEntities(customerId: string) {
    const params = new HttpParams().set('customerId', customerId)

    return this.http.get<RequestWrap<MenuItem[]>>(
      `${environment.baseApiUrl}${menusUrl}`,
      { observe: 'response', params }
    ).pipe(
      handleEmpty()
    )
  }
}
